import API from "./api";

// GET
export const getCallLogs = () => API.get("/EmployeeCallLogs");

// ADD
export const addCallLog = (data) =>
    API.post("/EmployeeCallLogs", data);

// UPDATE
export const updateCallLog = (id, data) =>
    API.put(`/EmployeeCallLogs/${id}`, data);

// DELETE
export const deleteCallLog = (id) =>
    API.delete(`/EmployeeCallLogs/permanent/${id}`);